import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { categoriesActions } from "../../../../redux/actions/categories";
import AddCategory from "./AddCategory";
import { alertsActions } from "../../../../redux/actions/alertsActions";

const mapStateToProps = state => {
  return {
    catregory: state.category,
    catList: state.categoryReducer.cviews,
    catStatus: state.categoryReducer.add,
    error: state.categoryReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    views: state.categoryReducer.views,
    catdetails: state.categoryReducer.catdetails,
    updatecat: state.categoryReducer.updatecat,
    loading: state.categoryReducer.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...categoriesActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCategory);



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/addCategory/index.js